import config from '../../../../config';
import { RECEIVE_PRODUCTS, REQUEST_PRODUCTS } from '../../../ActionsConst';
import { showToast } from '../../../core/actions/toast/ToastActions';
import { productSettings } from '../settings/SettingsActions';
import toastMsg from '../../../../data/toast';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import toastEvents from '../../../../analytics/events/toasts';

export const receiveProducts = (products) => ({
  type: RECEIVE_PRODUCTS,
  items: products,
});

export const productsApiCall = ({ method, url, callback, ids, excludedIds, urlConfig, requestId }) => ({
  url,
  method,
  callback,
  ids,
  excludedIds,
  requestId,
  type: REQUEST_PRODUCTS,
  urlConfig: urlConfig || {},
});

const toast = (id, error, message, action) =>
  showToast({
    error,
    id,
    message,
    action,
  });

const setNewProductsSelectState = (productsResponse, selectAll) => {
  if (selectAll === true) {
    return productsResponse.items.map((item) => ({ ...item, isChecked: true }));
  }
  return productsResponse.items;
};

function retryOrFail(dispatch, requestId) {
  const retryProductsRequest = () => {
    dispatch(productSettings({ isLoading: false }));
    AnalyticsClient.trackEvent(toastEvents.retryAction());
  };
  // Oops! Something went wrong. Please try again.
  dispatch(toast(requestId, true, toastMsg.generalErrorReceivedMessage, retryProductsRequest));
}

export const requestedProductsReceived = ({ jsonResponse, error, store, requestId, newRequest }) => {
  const { dispatch } = store;
  if (error) {
    retryOrFail(dispatch, requestId);
    return () => {};
  }
  const currentSettings = store.getState().productSettings;
  const currentStartIndex = currentSettings.start;
  const newItemsCount = jsonResponse.total;
  const productPageSize = config.page.products;
  const updatedProducts = setNewProductsSelectState(jsonResponse, currentSettings.selectAll);

  dispatch(receiveProducts(updatedProducts));
  dispatch(
    productSettings({
      isLoading: false,
      total: newItemsCount,
      hasMore: currentStartIndex + productPageSize < newItemsCount,
      start: currentStartIndex + productPageSize,
    }),
  );
  if (!newRequest) {
    dispatch(toast(requestId, false, 'Success.. Your products have been loaded.', () => {}));
  }
  return () => {};
};
